import createIcon from '../../createIcon';

/**
 * @component @name FavoriteBorder
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNSAyLjgyNDk1QzE0Ljc2IDIuODI0OTUgMTMuMDkgMy42MzQ5NSAxMiA0LjkxNDk1QzEwLjkxIDMuNjM0OTUgOS4yNCAyLjgyNDk1IDcuNSAyLjgyNDk1QzQuNDIgMi44MjQ5NSAyIDUuMjQ0OTUgMiA4LjMyNDk1QzIgMTIuMTA1IDUuNCAxNS4xODUgMTAuNTUgMTkuODY1TDEyIDIxLjE3NUwxMy40NSAxOS44NTVDMTguNiAxNS4xODUgMjIgMTIuMTA1IDIyIDguMzI0OTVDMjIgNS4yNDQ5NSAxOS41OCAyLjgyNDk1IDE2LjUgMi44MjQ5NVpNMTIuMSAxOC4zNzVMMTIgMTguNDc1TDExLjkgMTguMzc1QzcuMTQgMTQuMDY1IDQgMTEuMjE1IDQgOC4zMjQ5NUM0IDYuMzI0OTUgNS41IDQuODI0OTUgNy41IDQuODI0OTVDOS4wNCA0LjgyNDk1IDEwLjU0IDUuODE0OTUgMTEuMDcgNy4xODQ5NUgxMi45NEMxMy40NiA1LjgxNDk1IDE0Ljk2IDQuODI0OTUgMTYuNSA0LjgyNDk1QzE4LjUgNC44MjQ5NSAyMCA2LjMyNDk1IDIwIDguMzI0OTVDMjAgMTEuMjE1IDE2Ljg2IDE0LjA2NSAxMi4xIDE4LjM3NVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FavoriteBorder = createIcon('FavoriteBorder', [
  [
    'path',
    {
      d: 'M16.5 2.82495C14.76 2.82495 13.09 3.63495 12 4.91495C10.91 3.63495 9.24 2.82495 7.5 2.82495C4.42 2.82495 2 5.24495 2 8.32495C2 12.105 5.4 15.185 10.55 19.865L12 21.175L13.45 19.855C18.6 15.185 22 12.105 22 8.32495C22 5.24495 19.58 2.82495 16.5 2.82495ZM12.1 18.375L12 18.475L11.9 18.375C7.14 14.065 4 11.215 4 8.32495C4 6.32495 5.5 4.82495 7.5 4.82495C9.04 4.82495 10.54 5.81495 11.07 7.18495H12.94C13.46 5.81495 14.96 4.82495 16.5 4.82495C18.5 4.82495 20 6.32495 20 8.32495C20 11.215 16.86 14.065 12.1 18.375Z',
      key: '9oaxml',
    },
  ],
]);

export default FavoriteBorder;
